namespace GeniuzPOS.Purchase {
    export interface PoShipAddressForm {
        ShipId: Serenity.StringEditor;
        ShopId: Serenity.LookupEditor;
        WhsId: Serenity.LookupEditor;
        ShipName: Serenity.StringEditor;
        ShipLineAddress1: Serenity.StringEditor;
        ShipLineAddress2: Serenity.StringEditor;
        ShipLineAddress3: Serenity.StringEditor;
    }

    export class PoShipAddressForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PoShipAddress';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PoShipAddressForm.init)  {
                PoShipAddressForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(PoShipAddressForm, [
                    'ShipId', w0,
                    'ShopId', w1,
                    'WhsId', w1,
                    'ShipName', w0,
                    'ShipLineAddress1', w0,
                    'ShipLineAddress2', w0,
                    'ShipLineAddress3', w0
                ]);
            }
        }
    }
}
